
const scenarioIds = [
	'game1', 'game2'
];

const scenariosData = {
	game1: {
		id: 'game1',
		title: 'HTX GAME',
		url: 'htx',
		tasksData: require('data/game1-tasks').tasksData,
		results: [
			{
				maxPercentPoints: 10,
				title: `HTX Begynder`,
				text: `HTX-universet er stadig lidt af en gåde for dig ... endnu! Gå på opdagelse – der er meget fedt at finde ud af.`,
				trophy: 'duck'
			},
			{
				minPercentPoints: 11,
				maxPercentPoints: 20,
				title: `HTX Kender`,
				text: `Du har fanget de vigtigste basics. Du er på vej, men der er stadig mere at opdage om HTX.`,
				trophy: 'cup'
			},
			{
				minPercentPoints: 21,
				maxPercentPoints: 40,
				title: `HTX Skarp`,
				text: `Du har styr på det meste – faktisk så meget, at du snart kunne forklare HTX til andre.`,
				trophy: 'bronze'
			},
			{
				minPercentPoints: 41,
				maxPercentPoints: 69,
				title: `HTX Expert`,
				text: `Du er en vaskeægte HTX-ekspert. Det kan næsten ikke gøres bedre.`,
				trophy: 'silver'
			},
			{
				minPercentPoints: 70,
				title: `HTX All knowing`,
				text: `Du ved ALT om HTX. Måske burde du selv starte på HTX ... eller har du allerede gjort det?`,
				trophy: 'gold',
			}
		]
	},
	game2: {
		id: 'game2',
		title: 'HHX GAME',
		url: 'hhx',
		tasksData: require('data/game2-tasks').tasksData,
		results: [
			{
				maxPercentPoints: 10,
				title: `HHX Begynder`,
				text: `HHX-universet er stadig lidt af en gåde for dig ... endnu! Gå på opdagelse – der er meget fedt at finde ud af.`,
				trophy: 'duck'
			},
			{
				minPercentPoints: 11,
				maxPercentPoints: 20,
				title: `HHX Kender`,
				text: `Du har fanget de vigtigste basics. Du er på vej, men der er stadig mere at opdage om HHX.`,
				trophy: 'cup'
			},
			{
				minPercentPoints: 21,
				maxPercentPoints: 40,
				title: `HHX Skarp`,
				text: `Du har styr på det meste – faktisk så meget, at du snart kunne forklare HHX til andre.`,
				trophy: 'bronze'
			},
			{
				minPercentPoints: 41,
				maxPercentPoints: 69,
				title: `HHX Expert`,
				text: `Du er en vaskeægte HHX-ekspert. Det kan næsten ikke gøres bedre.`,
				trophy: 'silver'
			},
			{
				minPercentPoints: 70,
				title: `HHX All knowing`,
				text: `Du ved ALT om HHX. Måske burde du selv starte på HHX ... eller har du allerede gjort det?`,
				trophy: 'gold',
			}
		]
	}
};



export {
	scenarioIds,
	scenariosData
};